/*
 * @Description: 组织管理
 * @Author: wangwangwang
 * @Date: 2020-07-01 09:45:15
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-07-01 09:47:39
 */
import request from '@/utils/request'
export const Download = "/base/system/base/organization/export";

// 获取组织数据
export function queryPage(params) {
  return request({
    url: '/base/system/base/organization/query_page',
    method: 'post',
    data: params
  })
}

// 获取带权限
export function queryOrgPageByLimit(params) {
  return request({
    url: '/base/system/base/organization/query_org_page_limit',
    method: 'post',
    data: params
  })
}

// 获取用户管理的带权限
export function queryUserOrgPageByLimit(params) {
  return request({
    url: '/base/system/base/organization/query_org_permission_user',
    method: 'post',
    data: params
  })
}

export function queryPage2(params) {
  return request({
    url: '/base/system/base/organization/query_org_page',
    method: 'post',
    data: params
  })
}
// 保存组织数据
export function saveOrUpdate(params) {
  return request({
    url: '/base/system/base/organization/save_or_update',
    method: 'post',
    data: params
  })
}
// 修改数据状态
export function updateOrDelete(params) {
  return request({
    url: '/base/system/base/organization/batch_update_or_delete',
    method: 'post',
    data: params,
  })
}
//获取组织列表（旧）
export function getsList(params) {
  return request({
    url: '/base/system/base/organization/get_list',
    method: 'get',
    params,
  })
}
//获取组织列表（新）
export function queryOraganPage(data) {
  return request({
    url: '/base/system/base/organization/queryOraganPage',
    method: 'post',
    data,
  })
}

//获取组织列表 权限控制
export function queryPageByLimit(data) {
  return request({
    url: '/base/system/base/organization/queryOraganPageLimit ',
    method: 'post',
    data,
  })
}

export function usersaveOrUpdate(data) {
  return request({
    url: '/base/system/base/organization/user/save_or_update',
    method: 'post',
    data
  })
}
export function usergetList(params) {
  return request({
    url: '/base/system/base/organization/user/get_list',
    method: 'get',
    params
  })
}
export function get_attribute_list(params) {
  return request({
    url: '/base/system/base/organization/get_attribute_list',
    method: 'get',
    params
  })
}
export function update_sort_num(data) {
  return request({
    url: '/base/system/base/organization/update_sort_num',
    method: 'post',
    data
  })
}
/**查询组织是否绑定了用户  */
export function getOrgznizationBindingUser(data) {
  return request({
    url: '/base/system/base/organization/getOrgznizationBindingUser?id=' + data,
    method: 'post',
  })
}
/**移动组织 */
export function moveOrgznization(data1, data2) {
  return request({
    url: '/base/system/base/organization/moveOrgznization?parentId=' + data1 + '&id=' + data2,
    method: 'post',
  })
}

/**
 * 获取当前用户下的组织
 * @param {type: int, 1客户；2供应商；3往来协作单位} data 
 * @returns 
 */
export function getSpecialOrg(params) {
  return request({
    url: '/base/system/base/organization/queryOragan',
    params,
  })
}